import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { StorageAllocationsForOperatorParams } from 'src/apis/storage/types';
import { useStorageAllocationsForOperator } from 'src/apis/storage/use-storage-allocations-for-operator';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useStorageAllocationsForOperatorPageParams } from 'src/pages/storage/allocations/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const StorageAllocationsForOperators: FC<{
  storageServiceRoot: Successful<StorageServiceRootRequest>;
}> = ({ storageServiceRoot }) => {
  const pageParams = useStorageAllocationsForOperatorPageParams();

  const params = useMemo(() => {
    return {
      limit: pageParams.value.pageSize,
      offset: pageParams.value.start,
      offerName: pageParams.value.offerName,
      allocationBusinessId: pageParams.value.allocationBusinessId,
      shipperOrganisationId: pageParams.value.shipperOrganisationId.map(
        (shipper) => shipper.value
      ),
      storageLocationId: pageParams.value.storageLocationId.map(
        (location) => location.value
      ),
      runtimeStart: pageParams.value.runtimeStart,
      runtimeEnd: pageParams.value.runtimeEnd,
      sortBy: pageParams.value.sortBy,
      sortDirection: pageParams.value.sortDirection,
    } satisfies StorageAllocationsForOperatorParams;
  }, [pageParams.value]);

  const storageAllocations = useStorageAllocationsForOperator({
    storageServiceRoot,
    params,
  });

  if (storageAllocations.response == null) return <PageSpinner />;

  return (
    <Page
      pageParams={pageParams}
      storageAllocations={storageAllocations}
      storageServiceRoot={storageServiceRoot}
    />
  );
};
